import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

// No `name` — this overrides the app plugin's DefaultSignInPage (which also
// registers a nameless sign-in page) rather than adding a conflicting second one.
const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => (await import('./SignInPage')).SignInPage,
  },
});

/** Registers the wibblewabble branded passwordless sign-in page. */
export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});
